<template>
  <div>
    <b-modal
      ref="modal"
      :title="'Lançar Contas'"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      @hide="onHide()"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <account-select-input @input="setAccount($event)" />
            <!-- <select-input
              v-model="form.account.value"
              :alias="form.account.alias"
              :options="form.account.options"
            /> -->
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">Venda #{{ order.number }}</div>
        </div>
        <br />
        <template v-for="row in order.order_bill">
          <div class="row" :key="row.id">
            <div class="col-5">{{ paymentOptions[row.payment_method] }}</div>
            <div class="col-3">{{ row.value | decimal }}</div>
            <div class="col-3">{{ row.due_date | dateBr }}</div>
          </div>
          <br :key="'br' + row.id" />
        </template>
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Lançar contas
        </button>
      </div>

      <error-handler :error="error" />
      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >
    </b-modal>
  </div>
</template>

<script>
  import Filters from "./../../mixins/Filters.js";
  import Form from "./../../mixins/Form.js";
import AccountSelectInput from "@/components/account/inputs/AccountSelectInput";

  export default {
    components: {
      AccountSelectInput,
    },
    data: function() {
      return {
        order: [],

        error: null,

        alertData: {
          isVisible: false,
          message: null
        },

        form: new Form({
          order_id: {},
          account: {
            validate: { required: true },
            alias: "Selecione um caixa ou conta",
            options: {}
          }
        }),

        paymentOptions: {
          1: "Dinheiro",

          2: "Cheque",

          3: "Cartão de Crédito",

          4: "Cartão de Débito",

          5: "Crédito Loja",

          15: "Boleto Bancário",
          
          16: "Deposito Bancário",
          
          17:'PIX',
          
          18:'Carteira Digital',

          99: "Outros"
        },

        location: null
      };
    },

    // created() {
    //   this.$store.dispatch("account/getAccounts");
    // },

    computed: {
      editUrl() {
        return process.env.BASE_URL + "api/emitorderbill/edit/";
      },

      storeUrl() {
        return process.env.BASE_URL + "api/emitorderbill/store";
      }
    },

    methods: {
      async open(id) {
        this.$store.commit("showLoading");

        await this.$store.dispatch("account/getAccounts", { status: 1 });

        await this.select(id);

        this.$refs.modal.show();

        this.$store.commit("hideLoading");
      },

      async select(id) {
        this.$store.commit("showLoading");
        await axios
          .post(this.editUrl + id)
          .then(response => {
            this.setData(response.data);

            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      },

      store() {
        if (this.form.isValid()) {
          this.$store.commit("showLoading");
          axios
            .post(this.storeUrl, this.form.getValues())
            .then(response => {
              this.$store.commit("hideLoading");

              this.processSuccess();
            })
            .catch(error => {
              this.$store.commit("hideLoading");
              this.error = error;
            });
        } else {
          this.alertData.message = this.form.getFirstErrorMsg();

          this.alertData.isVisible = true;
        }
      },

      processSuccess() {
        this.$refs.modal.hide();
        this.$emit("stored");
      },

      onHide() {
        this.$emit("hide");
      },

      resetForm() {
        this.error = null;

        this.alertData.isVisible = false;

        this.form.reset();
      },

      setData(data) {
        this.order = data.order;

        this.form.order_id.value = data.order.id;

        for (let index in this.$store.state.account.accounts) {
          this.form.account.options[
            this.$store.state.account.accounts[index].id
          ] = this.$store.state.account.accounts[index].description;
        }
      },
    setAccount(account) {
      this.form.account.value = account.id;
      }
    }
  };
</script>

<style>
</style>
